import { createI18n } from 'vue-i18n'
import en from './locales/en'
import zhCN from './locales/zh-CN'

const messages = {
  en,
  'zh-CN': zhCN
}

// 从本地存储获取语言设置，默认跟随浏览器
const getBrowserLang = () => {
  try
  {
      
      const storedLang = localStorage.getItem('lang');

    // 2. 核心判断：存在值（非 null）则执行逻辑
    if (storedLang !== null) {
      console.log('获取到 lang 值：', storedLang); // 例如："zh-CN"、"en"
      // 后续逻辑：如设置页面语言、初始化多语言配置等
      return storedLang;
    } else {
      console.log('未获取到 lang 值(localStorage 中无该键）');
      // 兜底逻辑：如使用浏览器默认语言、设置默认值
      return 'zh-CN';
    }

      //旧的处理方式
      //const lang = navigator.language || 'en'
      //return lang.includes('zh') ? 'zh-CN' : 'en'
  }
  catch (error) {
    console.error('获取语言失败:', error);
    return 'zh-CN';
  }
}

const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: localStorage.getItem('lang') || getBrowserLang(),
  fallbackLocale: 'en',
  messages
})

export default i18n
  